import { render, staticRenderFns } from "./DevolucionTarimasComponent.vue?vue&type=template&id=136da670&"
import script from "./DevolucionTarimasComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionTarimasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports